import { useState, useMemo } from 'react';
import { Constants, Page_Padding } from '../../shared/constants';
import PollingCard from '../../shared/components/PollingCard';
import { Box, Grid2, Typography } from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import { useApartmentListForCourse, useGetcandidateVote } from '../../assets/api/useGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import SearchBar from '../../shared/components/SearchBar';

const CompetitionPolling = () => {
    const [filters, setFilters] = useState({});
    const [searchKeyword, setSearchKeyword] = useState("");
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const { data: candidateVote, isLoading } = useGetcandidateVote(filters);
    const ApartmentOptions = (apartmentList?.data || [])
        .filter(item =>
            ["Approved By Manager", "Accepted By Apartment", "Created"].includes(item?.terms_status)
        )
        .map(item => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        }));
    const filteredCandidates = useMemo(() => {
        if (!candidateVote?.data) return [];
        if (!searchKeyword.trim()) return candidateVote.data;

        const keyword = searchKeyword.trim().toLowerCase();

        return candidateVote.data.filter(item =>
            item.student_name?.toLowerCase().includes(keyword) ||
            item.parent_name?.toLowerCase().includes(keyword)
        );
    }, [candidateVote?.data, searchKeyword]);


    return (
        <Box className="body contact_us" px={Page_Padding}>
            <Grid2 container spacing={5}>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant='h6' color='red.main'>Design. Shine.</Typography>
                    <Typography variant='h5' my={1.5}>Win the Spotlight!</Typography>
                    <Typography variant='h4'>Tiny Designers, Big Dreams!</Typography>
                    <CustomDivider />
                    <Typography variant='body1' color='grey.600' fontWeight={200}>
                        Let your creativity take center stage! Submit your unique T-shirt design and let parents vote for their favorites. Big cheers, bright ideas, and awesome prizes await our little artists!
                    </Typography>
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Box
                        component={"img"}
                        src={Constants.customImages.pollingHeroImg}
                        sx={{ width: "100%" }}
                    />
                </Grid2>
            </Grid2>

            <CustomDivider />
            <Typography variant='h4'>Tiny Designers, Big Dreams!</Typography>
            <CustomDivider size={"2rem"} />
            <Typography variant='body1' color='grey.600' fontWeight={200}>
                Let your creativity take center stage! Submit your unique T-shirt design and let parents vote for their favorites.
            </Typography>

            <CustomDivider />
            <Typography variant='h5' my={1.5}>Search here & vote for your favourites</Typography>

            {/* Search Bar */}
            <Grid2 container>
                <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                    <SearchBar
                        // studentOptions={candidateVote?.data?.map(c => ({
                        //     id: c.id,
                        //     label: c.student_name
                        // })) || []}
                        apartmentOptions={ApartmentOptions}
                        onSearch={(keyword) => {
                            setSearchKeyword(keyword || "");
                        }}
                        onApartmentSelect={(apartmentId) => {
                            setFilters(prev => ({ ...prev, apartment_id: apartmentId || undefined }));
                        }}
                        placeholder={"Search By Parent's / Student's Name"}
                    />

                </Grid2>
            </Grid2>

            <CustomDivider size={"2rem"} />

            {/* Candidate List */}
            <Grid2 container spacing={5}>
                {isLoading ? (
                    [...Array(6)].map((_, index) => (
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                ) : filteredCandidates.length === 0 ? (
                    <Box textAlign="center" width="100%">
                        <Typography variant='h6'>Candidate not found.</Typography>
                    </Box>
                ) : (
                    filteredCandidates.map((item, index) => (
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <PollingCard item={item} />
                        </Grid2>
                    ))
                )}
            </Grid2>
        </Box>
    );
};

export default CompetitionPolling;
